"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = exports.HttpAdapters = exports.ClientAdapters = exports.ConfigurationErrors = void 0;
var ConfigurationErrors;
(function (ConfigurationErrors) {
    ConfigurationErrors["MissingLocaleError"] = "MissingLocaleError";
    ConfigurationErrors["MissingProductError"] = "MissingProductError";
    ConfigurationErrors["MissingProductNameError"] = "MissingProductNameError";
    ConfigurationErrors["MissingProductIdError"] = "MissingProductIdError";
    ConfigurationErrors["MissingSlaveIdError"] = "MissingSlaveIdError";
    ConfigurationErrors["PlatformTimeoutError"] = "PlatformTimeoutError";
    ConfigurationErrors["TimeoutError"] = "TimeoutError";
})(ConfigurationErrors || (exports.ConfigurationErrors = ConfigurationErrors = {}));
var ClientAdapters;
(function (ClientAdapters) {
    ClientAdapters["PostMessageAdapter"] = "PostMessageAdapter";
    ClientAdapters["FrameResizerAdapter"] = "FrameResizerAdapter";
    ClientAdapters["GravityGatewayAdapter"] = "GravityGatewayAdapter";
})(ClientAdapters || (exports.ClientAdapters = ClientAdapters = {}));
var HttpAdapters;
(function (HttpAdapters) {
    HttpAdapters["RouletteHttpAdapter"] = "RouletteHttpAdapter";
    HttpAdapters["GamesHttpAdapter"] = "GamesHttpAdapter";
    HttpAdapters["GamesStaticHttpAdapter"] = "GamesStaticHttpAdapter";
    HttpAdapters["LotteryHttpAdapter"] = "LotteryHttpAdapter";
    HttpAdapters["VSoccerHttpAdapter"] = "VSoccerHttpAdapter";
    HttpAdapters["CrashCashHttpAdapter"] = "CrashCashHttpAdapter";
    HttpAdapters["GamesHttpAdapterV2"] = "GamesHttpAdapterV2";
})(HttpAdapters || (exports.HttpAdapters = HttpAdapters = {}));
var TokenType;
(function (TokenType) {
    TokenType["Bearer"] = "Bearer";
})(TokenType || (exports.TokenType = TokenType = {}));
//# sourceMappingURL=Types.js.map